import { IListingResponse } from '@models/IListingResponse';
import { ISearchSummaryRow } from '@models/ISearchBlock';
import {
  ISearchSummaryResultType,
  ISearchSummaryRowResult,
} from '@models/ISearchSummaryRowResult';
import axios from 'axios';
import { useCallback, useState } from 'react';

const useSearchSummaryResults = (
  searchSummary: ISearchSummaryRow[],
  track?: boolean
) => {
  const [searchSummaryResults, setSearchSummaryResults] = useState<
    ISearchSummaryRowResult[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchSearchSummaryResults = useCallback(
    async (queryValue: string) => {
      const itemsRequests = searchSummary.map(({ endpoint, parameters }) =>
        axios.get<IListingResponse>(endpoint + parameters, {
          params: {
            query: queryValue,
            track,
          },
        })
      );

      const itemsResponses = await Promise.all(itemsRequests);
      const summaryResults = itemsResponses.map((itemsResponse, index) => ({
        title: searchSummary[index]!.title,
        viewAllLink: searchSummary[index]!.viewAllLink,
        pageType: searchSummary[index]!.pageType,
        results: itemsResponse.data.items as ISearchSummaryResultType[],
        totalCount: itemsResponse.data.total,
      }));

      setSearchSummaryResults(summaryResults);
      setIsLoading(false);
    },
    [searchSummary, track]
  );

  return {
    isLoading,
    searchSummaryResults,
    fetchSearchSummaryResults,
  };
};

export default useSearchSummaryResults;
